import { render, staticRenderFns } from "./send-order-dialog.vue?vue&type=template&id=4a089a38&"
import script from "./send-order-dialog.vue?vue&type=script&lang=js&"
export * from "./send-order-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports